<template>
	<div class="choose-actions">
		<egranty-section-divider
			:text="numberOfModules > 1 ? 'Działania programowe modułu ' + moduleNumber : 'Działania programowe projektu'"
			icon="flag"
			:show-print-info="showPrintInfo"
		/>

		<div  class="action-cards-wrap" style="display: flex">
			<div
				v-for="(action, index) in actions"
				:key="index"
				class="action-card"
			>

				<v-card class="choose-actions-card">
					<v-toolbar :color="getStatusColor(action)" dark style="margin: 0" class="">
						<h3>Działanie nr {{action.serialNumber}} {{getStatus(action)}}</h3>
						<v-spacer/>
						<offer-button
							class="no-print"
							v-if="!readonly && index !== 0"
							icon="arrow_drop_up"
							@click='moveActionUp(index)'
						></offer-button>
						<offer-button
							class="no-print"
							v-if="!readonly && index !== actions.length - 1"
							icon="arrow_drop_down"
							@click='moveActionDown(index)'
						></offer-button>
						<offer-button
							class="no-print"
							delete-button
							v-if="!readonly"
							text="Usuń działanie"
							icon="delete"
							@click='showRemoveActionDialog(index)'
						></offer-button>
					</v-toolbar>

					<egranty-text-input-field
						:disabled="readonly"
						class="mt-3 choose-action-place"
						v-model="action.action"
						label='Nazwa'
						:outline="false"
						:textarea="true"
						rows="1"
						:auto-grow="true"
						for="choose-actions-action-name"
						id="choose-actions-action-name"
					></egranty-text-input-field>

					<egranty-text-input-field class="choose-action-place"
						:disabled="readonly"
						v-model="action.place"
						label="Miejsce"
						for="choose-actions-place"
						id="choose-actions-place"
					></egranty-text-input-field>

					<egranty-text-input-field class="choose-action-place"
						:disabled="readonly"
						v-model="action.description"
						label="Opis"
						for="choose-actions-description"
						id="choose-actions-description"
						@input="sync"
						textarea=true
						autoGrow=true
					></egranty-text-input-field>


					<choose-beneficiaries-empty
						v-if="contestId !== null"
						:readonly="false"
						v-model="action.beneficiariesData"
						:contestId="contestId"
						id="choose-actions-group"
					></choose-beneficiaries-empty>


					<div class="choose-actions-realization-date"
						v-for="(dates, datesIndex) in action.realizationDates"
						:key='datesIndex'>
						<v-layout row>
							<egranty-date-picker
								:disabled="readonly"
								v-model="dates.start"
								label="Początek"
								for="choose-actions-start"
								id="choose-actions-start"
								:min="minStart"
								:max="maxEnd"
							></egranty-date-picker>

							<egranty-date-picker
								:disabled="readonly"
								v-model="dates.end"
								label="Koniec"
								for="choose-actions-end"
								id="choose-actions-end"

								:min="minStart"
								:max="maxEnd"
							></egranty-date-picker>

							<offer-button
								v-if="!readonly"
								delete-button
								text="Usuń"
								icon="delete"
								@click="action.realizationDates.splice(datesIndex, 1)"
							></offer-button>

						</v-layout>
					</div>
					<offer-button class="choose-actions-add-date no-print"
						v-if="!readonly"
						text="Dodaj termin realizacji"
						icon="date_range"
						@click="addRealizationDate(index)"
					></offer-button>


					<egranty-validation-error
						v-for="error in action.errors"
						:key="error"
						:error=error
					></egranty-validation-error>
				</v-card>


			</div>

			<div v-if="!actions.length">
				<egranty-validation-error
					:error="error"
				></egranty-validation-error>
			</div>
		</div>
		<offer-button
			class="no-print"
			:text="actions.length === 0 ? 'Dodaj działanie' : 'Dodaj kolejne działanie'"
			icon="add"
		></offer-button>
		<v-dialog v-model="removeActionDialog" width="500">
		<v-card>
			<v-card-title class="headline" primary-title>
				Usunięcie działania programowego
			</v-card-title>

			<v-card-text>
				Czy na pewno chcesz usunąć działanie programowe i powiązane z nim koszty programowe?
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="removeAction(removeActionDialogItemIndex)">
					Tak
				</v-btn>
				<v-btn color="blue" @click="removeActionDialog = false; removeActionDialogItemIndex = null;">
					Nie
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	</div>
</template>

<script>
	import EgrantyTextInputField from "../../../genericComponents/EgrantyTextInputField";
	import ChooseBeneficiariesEmpty from "@/view/landing_page/components/ChooseBeneficiariesEmpty";
	import OfferButton from "@/view/logged/offer/components/OfferButton";
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";
	import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "ChooseActionsEmpty",

		components: {
			EgrantySectionDivider, EgrantyValidationError, EgrantyDatePicker, OfferButton, ChooseBeneficiariesEmpty, EgrantyTextInputField
		},

		data() {
			return {
				error: "",
				actions: [],
				removeActionDialog: false,
				removeActionDialogItemIndex: null,
			};
		},

		methods: {

			getStatusColor (action) {
				if (this.getStatus(action) === '(Usunięte)') {
					return "red lighten-2";
				}
				if (this.getStatus(action) === '(Nowe)') {
					return "green lighten-2";
				}
				if (this.getStatus(action) === '(Zmienione)') {
					return "blue lighten-2";
				}
				return "grey lighten";
			},

			getStatus (action) {
				if (this.oldVersion) {
					let found = this.oldVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Nowe)";
					} else {
						action.id = 0;
						found.id = 0;
						if (JSON.stringify(action) !== JSON.stringify(found)) {
							return "(Zmienione)";
						}
					}
				}
				if (this.newVersion) {
					let found = this.newVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Usunięte)";
					} else {
						action.id = 0;
						found.id = 0;
						if (JSON.stringify(action) !== JSON.stringify(found)) {
							return "(Zmienione)";
						}
					}
				}

				return "";
			},

			validate() {
				let valid = true;

				if (this.actions.length === 0) {
					valid &= false;
					this.error = "Proszę dodać co najmniej jedno działanie";
				}
				for (let action of this.actions) {
					valid &= this.validateAction(action);
				}
				if (valid) { //valid tutaj jest 1 lub 0, jak zwracamy przez return valid to uznaje to jako błąd
					return true;
				}
				return false;
			},

			validateAction(action) {
				this.$set(action, 'errors', []);
				if (action.action === '') {
					action.errors.push("Proszę uzupełnić nazwę działania");
				}
				if (action.place === '') {
					action.errors.push("Proszę uzupełnić miejsce działania");
				}
        if (!action.beneficiariesData.otherBeneficiary && !action.beneficiariesData.selected.length) {
          action.errors.push("Proszę uzupełnić grupę docelową");
        }
				if (!action.realizationDates.length) {
					action.errors.push("Proszę dodać co najmniej jeden termin realizacji działania");
				}
				for (var date of action.realizationDates) {
					if (!date.start || !date.end) {
						action.errors.push('Proszę uzupełnić brakujące terminy realizacji działań');
						break;
					}
					if (date.start > date.end) {
						action.errors.push('Daty końców terminów realizacji działań nie mogą być wcześniejsze niż ich początków');
						break;
					}

					if (date.start < this.minStart) {
						action.errors.push('Daty początków terminów realizacji działań nie mogą być wcześniejsze niż data rozpoczęcia modułu');
						break;
					}

					if (date.end > this.maxEnd) {
						action.errors.push('Daty końców terminów realizacji działań nie mogą być późniejsze niż data zakończenia modułu');
						break;
					}
				}
				return action.errors.length === 0;
			},

      moveActionUp(index) {
        let tmp = this.actions[index];
        this.actions[index] = this.actions[index - 1];
        this.actions[index - 1] = tmp;
        let serialTmp = this.actions[index].serialNumber;
        this.actions[index].serialNumber = this.actions[index - 1].serialNumber;
        this.actions[index - 1].serialNumber = serialTmp;
        this.$emit("update:actionsData", this.actions);
      },

      moveActionDown(index) {
        let tmp = this.actions[index];
        this.actions[index] = this.actions[index + 1];
        this.actions[index + 1] = tmp;
        let serialTmp = this.actions[index].serialNumber;
        this.actions[index].serialNumber = this.actions[index + 1].serialNumber;
        this.actions[index + 1].serialNumber = serialTmp;
        this.$emit("update:actionsData", this.actions);
      },
	  		showRemoveActionDialog(index){
				this.removeActionDialog = true;
				this.removeActionDialogItemIndex= index;
			},

			removeAction(index) {
				this.actions.splice(index, 1);
				this.reassignSerialNumbers();
				this.removeActionDialog = false;
				this.removeActionDialogItemIndex= null;
			},

			addRealizationDate(index) {
				this.actions[index].realizationDates.push(
					{
						start: "",
						end: "",
					},
				);
			},

			addAction() {
				this.actions.push(
					{
            id: null,
            serialNumber: null,
            action: "",
						place: "",
						beneficiariesData: {
              otherBeneficiary: null,
              selected: [],
            },
						realizationDates: [
							{
								start: "",
								end: "",
							}
						],
            costs: [],
          });
				// this.reassignSerialNumbers();
			},

			reassignSerialNumbers() {
        if (this.readonly) return;

				for (let action of this.actions) {
					if (!this.isSerialNumberPermanentlyTaken(action.serialNumber)) {
						action.serialNumber = null;
					}
				}

				for (let action of this.actions) {
					if (!this.isSerialNumberPermanentlyTaken(action.serialNumber)) {
						action.serialNumber = this.getSerialNumber();
					}
				}
				this.actions = this.actions.sort((a,b) => a.serialNumber - b.serialNumber);
			},

			isSerialNumberPermanentlyTaken(serialNumber) {
				for (let action of this.takenSerialNumbers.takenActionsSerialNumbers) {
					if (action.actionSerialNumber === serialNumber) {
						return true;
					}
				}
				return false;
			},

			getSerialNumber() {
				let freeNumber = 0;
				let failed;
				do {
					failed = false;
					freeNumber++;
					for (let action of this.actions) {
						if (action.serialNumber === freeNumber) {
							failed = true;
						}
					}
					for (let action of this.takenSerialNumbers.takenActionsSerialNumbers) {
						if (action.actionSerialNumber === freeNumber) {
							failed = true;
						}
					}
				} while (failed);
				return freeNumber;
			},
		},

        created() {
            this.addAction();
        },

		props: {
			takenSerialNumbers: {},
			contestId: null,
			readonly: {
				default: false
			},
			actionsData: {},
			oldVersion: {},
			newVersion: {},
			moduleId: {},
			minStart: String,
			maxEnd: String,
			moduleNumber: {
				default: "",
			},
			numberOfModules: {
				default: 0,
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};
</script>

<style scoped>

	.choose-actions .theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.choose-actions .v-input__control {
		margin-left: 20px;
		margin-right: 20px;
	}

	.choose-action-place {
		padding-left: 10px;
		padding-right: 10px;
	}

	.choose-actions-realization-date {
		padding-left: 10px;
		padding-right: 10px;
	}

	.grey {
		background-color: #0052A5 !important;
	}
	.action-cards-wrap {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}
	.action-card {
		flex: 0 50%;
	}
	.choose-actions-card {
		height: 100%;
	}
/*
	strong {
		font-size: 20px !important;
	}

	.application.mediumFont strong {
		font-size: 22px !important;
}

	.application.largeFont strong {
		font-size: 24px !important;
} */
</style>
<style>
	.toolbar-action-card .v-toolbar__content {
		justify-content: space-between;
	}
</style>
